module.exports = __webpack_public_path__ + "static/img/2_1_7.1ced3d21.jpg";